import Nullstack from 'nullstack';
export default function IconExchangeOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-exchange-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "6",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M19 8v5c0 .594 -.104 1.164 -.294 1.692m-1.692 2.298a4.978 4.978 0 0 1 -3.014 1.01h-3l3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M14 21l-3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M5 16v-5c0 -1.632 .782 -3.082 1.992 -3.995m3.008 -1.005h3l-3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M11.501 7.499l1.499 -1.499"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}